import dayjs from 'dayjs';

export function formatDate(date: string) {
  return dayjs(date).format('ddd MMMM DD, YYYY');
}

export function formatTime(time: string) {
  return dayjs(time).format('hh:mm A');
}

export function reverseFormatTime(time: string) {
  return dayjs(`${dayjs().format('YYYY-MM-DD')} ${time}`);
}

export function getVal(val: any) {
  return val == null ? ' - ' : val;
}

/**
 * Formats a phone number string for display
 * Converts "+11234567890" to "+1 123-456-7890"
 * @param phone - Phone number string (e.g., "+11234567890")
 * @returns Formatted phone number string (e.g., "+1 123-456-7890") or original string if invalid
 */
export function formatPhoneForDisplay(phone: string | null | undefined): string {
  if (!phone) return '-';

  // Remove all non-digit characters except the leading +
  const digitsOnly = phone.replace(/\D/g, '');

  // If it starts with 1 and has 11 digits, format as US number
  if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    const areaCode = digitsOnly.slice(1, 4);
    const firstPart = digitsOnly.slice(4, 7);
    const lastPart = digitsOnly.slice(7, 11);
    return `+1 ${areaCode}-${firstPart}-${lastPart}`;
  }

  // If it has 10 digits, assume it's missing country code
  if (digitsOnly.length === 10) {
    const areaCode = digitsOnly.slice(0, 3);
    const firstPart = digitsOnly.slice(3, 6);
    const lastPart = digitsOnly.slice(6, 10);
    return `+1 ${areaCode}-${firstPart}-${lastPart}`;
  }

  // If it starts with + and has country code, try to format
  if (phone.startsWith('+')) {
    // Extract country code (1-3 digits after +)
    const match = phone.match(/^(\+\d{1,3})(\d+)$/);
    if (match) {
      const countryCode = match[1];
      const numberPart = match[2].replace(/\D/g, '');

      // For US/Canada (+1), format the remaining 10 digits
      if (countryCode === '+1' && numberPart.length === 10) {
        const areaCode = numberPart.slice(0, 3);
        const firstPart = numberPart.slice(3, 6);
        const lastPart = numberPart.slice(6, 10);
        return `${countryCode} ${areaCode}-${firstPart}-${lastPart}`;
      }
    }
  }

  // Return original if we can't format it
  return phone;
}
